module.exports = __webpack_public_path__ + "img/icon-warning-thunder-2.33d8e7d9.svg";